import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Alert from '@mui/material/Alert';
// dirty
const useStyles = makeStyles(() => {
    return {
        fixAlert: {
            '& > .MuiAlert-message': {
                display: 'block',
            }
        }
    }
});

const RichAlert = ({children, ...rest}) => {
    const classes = useStyles()
    return (
        <Alert {...rest} classes={classes.fixAlert}>
            {children}
        </Alert>
    );
};

export default RichAlert;